// The cmx mark: five bars, widening left to right, in the text colour. One copy for every page (the
// landing, the sign-in pages, the signed-in chrome); favicon.svg and the Mac icon (ios/Mac/AppIcon.svg)
// draw the same bars. Drawn on the design's 176 grid (Figma "[CMX] Landing Page", icon 175:56193),
// redrawn as five bars 13 apart, widths in the ratio 1:2:3:5:8.

const BARS = 'M0 0H6.5263V176H0ZM19.5263 0H32.5789V176H19.5263ZM45.5789 0H65.1578V176H45.5789ZM78.1579 0H110.7895V176H78.1579ZM123.7895 0H176V176H123.7895Z';

export function CmxMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 176 176" aria-hidden="true" focusable="false">
      <path fill="currentColor" d={BARS} />
    </svg>
  );
}
